// src/i18n.ts
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'
import fr from './locales/fr.json'
import it from './locales/it.json'


const messages = {
  en,
  de,
  fr,
  it
}

const i18n = createI18n({
  legacy: false,
  compositionOnly: false,
  locale: 'de',
  fallbackLocale: 'en',
  messages
})

export default i18n
